// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federinstallation/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federinstallationDE: PageEntry = {
  id: "post.federinstallation",
  locale: "de",
  slug: "federinstallation",
  seo: {
    title: "Glossar: Federinstallation einfach erklärt | Dietz GmbH",
    description: "Die Federinstallation bezieht sich auf den Prozess, bei dem Federn in ein bestimmtes mechanisches System eingebaut werden. Dieser Schritt ist entscheidend, um die Feder in ihrer vo",
  },
  type: "post",
  h1: "Glossar: Federinstallation einfach erklärt",
  intro: "Die Federinstallation bezieht sich auf den Prozess, bei dem Federn in ein bestimmtes mechanisches System eingebaut werden. Dieser Schritt ist entscheidend, um die Feder in ihrer vorgesehenen Funktion optimal wirken zu lassen. Die Federinstallation erfordert präzise Ausrichtung, Fixierung und gegebenenfalls die Anwendung von Montagetechniken. Bei der Installation ist darauf zu achten, dass die Feder nicht überlastet wird und ihre Position sowie Ausrichtung den Konstruktionsanforderungen entsprechen. Eine ordnungsgemäße Federinstallation trägt dazu bei, die Leistung und Lebensdauer der Feder in einem System zu maximieren.",
  blocks: [

  ],
};
